export default "__VITE_PUBLIC_ASSET__ac115535__"